/* eslint-disable @typescript-eslint/no-explicit-any */
import { graphqlFetch } from '@/utils/graphqlFetch';
import { GET_PACKAGES } from '../queries/package';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  CreateSubscriptionPackagesInput,
  MutationCreateSubscriptionPackagesArgs,
  SubscriptionPackagesOutput,
  UpdateSubscriptionPackagesInput,
} from '../gql/graphql';
import {
  CREATE_PACKAGE,
  DELETE_PACKAGE,
  UPDATE_PACKAGE,
} from '../mutations/package';

export const useGetPackages = () => {
  return useQuery<SubscriptionPackagesOutput[], Error>({
    queryKey: ['packages'],
    queryFn: async () => {
      const data = await graphqlFetch<
        { getAllSubsciptionPackages: SubscriptionPackagesOutput[] },
        { query: any }
      >(GET_PACKAGES);
      return data.getAllSubsciptionPackages;
    },
  });
};

export const useCreatePackage = () => {
  const queryClient = useQueryClient();
  return useMutation<
    SubscriptionPackagesOutput,
    Error,
    CreateSubscriptionPackagesInput
  >({
    mutationFn: async (input) => {
      const data = await graphqlFetch<
        {
          createSubscriptionPackages: SubscriptionPackagesOutput;
        },
        MutationCreateSubscriptionPackagesArgs
      >(CREATE_PACKAGE, { input });
      return data.createSubscriptionPackages;
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['packages'],
      }),
  });
};

export const useUpdatePackage = () => {
  const queryClient = useQueryClient();
  return useMutation<
    UpdateSubscriptionPackagesInput,
    Error,
    {
      input: UpdateSubscriptionPackagesInput;
      updateSubscriptionPackageId: string;
    }
  >({
    mutationFn: async ({ input, updateSubscriptionPackageId }) => {
      const data = await graphqlFetch<
        {
          updateSubscriptionPackage: UpdateSubscriptionPackagesInput;
        },
        // Variables du document ($updateSubscriptionPackageId → arg id)
        {
          input: UpdateSubscriptionPackagesInput;
          updateSubscriptionPackageId: string;
        }
      >(UPDATE_PACKAGE, { input, updateSubscriptionPackageId });
      return data.updateSubscriptionPackage;
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['packages'],
      }),
  });
};

export const useDeletePackage = () => {
  const queryClient = useQueryClient();
  return useMutation<boolean, Error, { removeSubscriptionPackageId: string }>({
    mutationFn: async ({ removeSubscriptionPackageId }) => {
      await graphqlFetch(DELETE_PACKAGE, { removeSubscriptionPackageId });
      return true;
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['packages'],
      }),
  });
};
